class ConnectMarketoForm {
    constructor(mktoFormConfig, el) {
        this.formDataEl = el;
        this.marketoFormId = this.formDataEl.dataset.newsletterBlocks;
        if (!this.marketoFormId) return;

        this.fieldsEls = this.formDataEl.querySelectorAll('[data-newsletter-checkbox]');
        this.form = document.querySelector('[data-newsletter-form]');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.submitButtonEl = this.form.querySelector('[type="submit"]');
        this.fieldName = 'FirstName';
        this.fieldEmail = 'Email';
        this.fieldNameEl = this.form.querySelector('[name="firstName"]');
        this.fieldEmailEl = this.form.querySelector('[name="email"]');
        this.thankyouMsg = this.form.querySelector('.thankyou-msg');

        this.selectAllEl = document.querySelector('.select-all a');
        if (this.selectAllEl) {
            this.selectAllEl.addEventListener('click', this.toggleAllCheckboxes.bind(this));
        }

        this.loadMarketoForm(mktoFormConfig, this.marketoFormId);
        this.initEvents();
    }

    initEvents() {
        this.fieldsEls.forEach(checkbox => {
            checkbox.style.pointerEvents = 'auto';
            checkbox.addEventListener('click', this.selectNewsletters.bind(this));
        });

        this.fieldNameEl.addEventListener('input', this.inputFieldChange.bind(this));
        this.fieldEmailEl.addEventListener('input', this.inputFieldChange.bind(this));
    }

    selectNewsletters(e) {
        if (e.target.tagName !== 'A') {
            e.preventDefault();

            const checkbox = e.currentTarget;
            checkbox.classList.toggle('selected');

            this.updateSubmitButton();
        }
    }

    inputFieldChange(e) {
        this.updateSubmitButton();
    }

    updateSubmitButton() {
        this.submitButtonEl.disabled = !(this.isNameValid() && this.isEmailValid() && this.isAnySelected());
    }

    isAnySelected() {
        for (let checkbox of this.fieldsEls) {
            if (checkbox.classList.contains('selected')) {
                return true;
            }
        }
        return false;
    }

    isNameValid() {
        return this.fieldNameEl.value.length > 0;
    }

    isEmailValid() {
        return this.fieldEmailEl.value.length > 0;
    }

    loadMarketoForm(config, formId) {
        const loadForm = MktoForms2.loadForm.bind(
            MktoForms2,
            config.podId,
            config.munchkinId,
            formId
        );

        loadForm((form) => {
            this.marketoForm = form;
        });
    }

    onSubmit(e) {
        e.preventDefault();
        this.validate();
    }

    validate() {
        let valid = true;

        const marketoFieldData = {};
        marketoFieldData[this.fieldName] = this.fieldNameEl.value;
        marketoFieldData[this.fieldEmail] = this.fieldEmailEl.value;

        this.fieldsEls.forEach(field => {
            const marketoFieldId = field.dataset.newsletterCheckbox;

            if (field.classList.contains('selected')) {
                marketoFieldData[marketoFieldId] = 'yes';
            }
        });

        if (valid) {
            this.populateAndSubmit(marketoFieldData);
        }

        return valid;
    }

    populateAndSubmit(marketoFieldData) {
        this.marketoForm.setValues(marketoFieldData);

        this.marketoForm.onSuccess(() => {
            this.form.classList.add('success');
            this.thankyouMsg.style.display = 'block';
        });

        this.marketoForm.submit();
    }

    toggleAllCheckboxes(e) {
        e.preventDefault();

        const allSelected = Array.from(this.fieldsEls).every(checkbox => checkbox.classList.contains('selected'));

        this.fieldsEls.forEach(checkbox => {
            if (allSelected) {
                checkbox.classList.remove('selected');
            } else {
                checkbox.classList.add('selected');
            }
        });
        this.updateSubmitButton();
    }
}

export default ConnectMarketoForm;
